<template lang="pug">

div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md(v-if="businessBooks.edges && businessBooks.edges.length")
    .grid
      .column.is-desktop-4.u-mb-sm
        h2 {{$t('business')}}
        p.u-text-lg {{$t('businessDesc')}}
        .u-mt-xs
          AppLink(to="/books/business" class="button-link is-medium" :title="$t('viewMore')") {{$t('viewMore')}}
      template(v-for="({ node }, idx) in businessBooks.edges" )
        .column.is-desktop-4.is-tablet-6.u-mb-xs(v-if="idx == 0 || idx == 1" :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" ratio="4:5")
        .column.is-tablet-6.u-mb-xs(v-else :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" :boxed="node.placeholderColor")


  .u-divider.u-mt-md(v-if="designBooks.edges && designBooks.edges.length")

  section.u-mt-md(v-if="designBooks.edges && designBooks.edges.length")
    .grid
      .column.is-desktop-4.u-mb-sm
        h2 {{$t('design')}}
        p.u-text-lg {{$t('designDesc')}}
        .u-mt-xs
          AppLink(to="/books/design" class="button-link is-medium" :title="$t('viewMore')") {{$t('viewMore')}}
      template(v-for="({ node }, idx) in designBooks.edges" )
        .column.is-desktop-4.is-tablet-6.u-mb-xs(v-if="idx == 0 || idx == 1" :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" ratio="4:5")
        .column.is-tablet-6.u-mb-xs(v-else :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" :boxed="node.placeholderColor")

  .u-divider.u-mt-md(v-if="codeBooks.edges && codeBooks.edges.length")

  section.u-mt-md(v-if="codeBooks.edges && codeBooks.edges.length")
    .grid
      .column.is-desktop-4.u-mb-sm
        h2 {{$t('code')}}
        p.u-text-lg {{$t('codeDesc')}}
        .u-mt-xs
          AppLink(to="/books/explore" class="button-link is-medium" :title="$t('viewMore')") {{$t('viewMore')}}
      template(v-for="({ node }, idx) in codeBooks.edges")
        .column.is-desktop-4.is-tablet-6.u-mb-xs(v-if="idx == 0 || idx == 1" :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" ratio="4:5")
        .column.is-tablet-6.u-mb-xs(v-else :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" :boxed="node.placeholderColor")

  .u-divider.u-mt-md(v-if="technologyBooks.edges && technologyBooks.edges.length" )

  section.u-mt-md(v-if="technologyBooks.edges && technologyBooks.edges.length" )
    .grid
      .column.is-desktop-4.u-mb-sm
        h2 {{$t('technology')}}
        p.u-text-lg {{$t('technologyDesc')}}
        .u-mt-xs
          AppLink(to="/books/culture" class="button-link is-medium" :title="$t('viewMore')") {{$t('viewMore')}}
      template(v-for="({ node }, idx) in technologyBooks.edges")
        .column.is-desktop-4.is-tablet-6.u-mb-xs(v-if="idx == 0 || idx == 1" :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" ratio="4:5")
        .column.is-tablet-6.u-mb-xs(v-else :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" :boxed="node.backgroundColor")

  section.u-mt-md(v-if="leadershipBooks.edges && leadershipBooks.edges.length" )
    .grid
      .column.is-desktop-4.u-mb-sm
        h2 {{$t('leadership')}}
        p.u-text-lg {{$t('leadershipDesc')}}
        .u-mt-xs
          AppLink(to="/books/leadership" class="button-link is-medium" :title="$t('viewMore')") {{$t('viewMore')}}
      template(v-for="({ node }, idx) in leadershipBooks.edges")
        .column.is-desktop-4.is-tablet-6.u-mb-xs(v-if="idx == 0 || idx == 1" :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" ratio="4:5")
        .column.is-tablet-6.u-mb-xs(v-else :key="node.id")
          AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" :boxed="node.backgroundColor")

  //- .u-divider.u-mt-md(v-if="cultureBooks.edges && cultureBooks.edges.length")

  //- section.u-mt-md(v-if="cultureBooks.edges && cultureBooks.edges.length")
  //-   .grid
  //-     .column.is-desktop-4.u-mb-sm
  //-       h2 {{$t('culture')}}
  //-       p.u-text-lg {{$t('cultureDesc')}}
  //-       .u-mt-xs
  //-         AppLink(to="/books/culture" class="button-link is-medium" :title="$t('viewMore')") {{$t('viewMore')}}
  //-     template(v-for="({ node }, idx) in cultureBooks.edges")
  //-       .column.is-desktop-4.is-tablet-6.u-mb-xs(v-if="idx == 0 || idx == 1" :key="node.id")
  //-         AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" ratio="4:5")
  //-       .column.is-tablet-6.u-mb-xs(v-else :key="node.id")
  //-         AppCard(:img="node.thumb" :title="node.title" :url="`/books/${node.slug}`" :boxed="node.backgroundColor")

  .u-mb-md

</template>

<script>
import { BooksCollection } from '~/graphql/Book.gql';

export default {
  scrollToTop: true,
  meta: {
    logoText: 'books',
    theme: 'books'
  },
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/share/books.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/share/books.png'
        }
      ]
    };
  },
  async asyncData({ app, error }) {
    try {
      const { data } = await app.$api.query({
        query: BooksCollection
      });

      const payload = Object.freeze(data);

      return {
        codeBooks: payload.code,
        designBooks: payload.design,
        technologyBooks: payload.tech,
        cultureBooks: payload.culture,
        businessBooks: payload.business,
        leadershipBooks: payload.leadership
      };
    } catch (err) {
      console.error(err);
      error({
        statusCode: 500,
        message: err.message
      });
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Books",
    "pageDesc":"Explore Baianat library of books and guides. Get to know the what and how of design, business, code and technology.",
    "mantra":"Books in  |every field.",
    "business":"Business",
    "businessDesc":"In depth materials to help businesses and individuals accelerate their processes.",
    "leadership":"Leadership",
    "leadershipDesc":"Books that takes you to a whole new level of creativity and leadership.",
    "design":"Design",
    "designDesc":"Recharge your creative battery with the essential principles and theories of design.",
    "code":"Code",
    "codeDesc":"Read more on the latest hacks for both mobile and web development careers.",
    "technology":"Technology",
    "technologyDesc":"Feed the geek inside and build up your knowledge base in various technology branches.",
    "culture":"Culture",
    "cultureDesc":"Introducing our guiding values, attitudes, beliefs in every aspect of Baianat culture."
  },
  "ar": {
    "pageTitle":"كتب بيانات",
    "pageDesc":"اكتشف مكتبة بيانات للكتب المتنوعة و التي تتضمن مواضيع حول التصميم و الأعمال التجارية و البرمجة والتكنولوجيا والأنيميشن.",
    "mantra":"كتب في مختلف |المجالات.",
    "business":"بيزنس",
    "businessDesc":"نساعد الأفراد والشركات على تحسين عملياتهم عبر مواد مكثفة.",
    "design":"تصميم",
    "designDesc":"أعد شحن بطاريتك الإبداعية من خلال المبادئ الأساسية ونظريات التصميم.",
    "code":"البرمجة",
    "codeDesc":"اقرأ المزيد عن أحدث النصائح حول  تطوير الموقع الإلكتروني وتطبيقات الجوال. ",
    "technology":"التكنولوجيا",
    "technologyDesc":"زود معرفتك و غذي الشغف بداخلك في فروع التكنولوجيا المختلفة. ",
    "culture":"ثقافة بيانات",
    "cultureDesc":"مقدمة لقيمنا و مبادئنا ومواقفنا في كل جانب من جوانب بيانات. "
  }
}
</i18n>
